import { useEffect } from 'react';

/**
 * Sets a unique <title> and updates the existing <meta name="description">
 * for a page. Uses the same document.title / document.head approach the city
 * pages already use (no head-management library). Restores the previous values
 * on unmount so navigating between SPA routes doesn't leak stale tags.
 */
export function useDocumentHead(title: string, description: string) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute('content') ?? null;
    if (metaDesc) metaDesc.setAttribute('content', description);

    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc !== null) metaDesc.setAttribute('content', prevDesc);
    };
  }, [title, description]);
}
